export const CombinedShapeWarning = () => (
  <svg
    width="148"
    height="72"
    viewBox="0 0 148 72"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient x1="14.755%" y1="54.472%" x2="90.596%" y2="47.392%" id="lns10j587c">
        <stop stopColor="#FF6B00" offset="0%" />
        <stop stopColor="#EDE314" offset="100%" />
      </linearGradient>
      <filter
        x="-8.5%"
        y="-10.8%"
        width="116.9%"
        height="138.3%"
        filterUnits="objectBoundingBox"
        id="y0s7jyvcka"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M38 189c9.815 0 18.529 4.713 24.002 12H126c9.941 0 18 8.059 18 18s-8.059 18-18 18l-63.999.001C56.528 244.287 47.814 249 38 249c-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30z"
        id="lfqh7rhm7b"
      />
    </defs>
    <g transform="translate(-2 -188)" fill="none" fillRule="evenodd">
      <use fill="#000" filter="url(#y0s7jyvcka)" xlinkHref="#lfqh7rhm7b" />
      <use fill="url(#lns10j587c)" xlinkHref="#lfqh7rhm7b" />
    </g>
  </svg>
);
